<template>
    <div class="w100 bg-w">
        <div class="w120 pt20 mc">
            <el-row :gutter="20">
                <el-col
                        :style="`width: ${handleWidth(moduleData.cardCol)}`"
                        v-for="item in moduleData.cardModules"
                        :key="item.code"
                >
                    <div class="home-card po-r">
                        <!--规章制度、业务流程和常用下载-->
                        <div class="titleClass grey" v-if="item.code == 'TINFO_RULES' || item.code == 'TINFO_BUSINESS' || item.code == 'TINFO_DOWNLOAD'">
                            <div class="flex-box al-c mb10" style="color: #024A84;">
                                <span class="ml10 font-14">{{item.title}}</span>
                            </div>
                            <div  style="cursor: pointer;">
                                <i class="el-icon-refresh" style="padding: 0 3px;font-size: 14px" @click="iconClick(item.code)"></i>
                                <span @click="goPagination(item.code)">更多</span>
                                <i class="el-icon-arrow-right"></i>
                            </div>
                        </div>
                        <div class="stasticCla" v-if="item.code == 'TINFO_RULES'">
                            <p class="po-r mt10 mb10 font-12 ellipsis cu-p flex-box msg-item"  v-for="(e, i) in rulesList" :key="i" >
                                <span class="flex-1 mr10 ellipsis" @click="goHref(e, '/notifyDetail')">{{e.name}}</span>
                                <span class="grey">{{e.createTime}}</span>
                            </p>
                            <div
                                    v-if="!rulesList.length"
                                    class="po-r mt10 mb10 font-16 ellipsis cu-p flex-box msg-item"
                            >
                                <span>暂无数据</span>
                            </div>
                        </div>
                        <div class="stasticCla" v-if="item.code == 'TINFO_BUSINESS'">
                            <p class="po-r mt10 mb10 font-12 ellipsis cu-p flex-box msg-item"  v-for="(e, i) in businessList" :key="i" >
                                <span class="flex-1 mr10 ellipsis" @click="goHref(e, '/notifyDetail')">{{e.name}}</span>
                                <span class="grey">{{e.createTime}}</span>
                            </p>
                            <div
                                    v-if="!businessList.length"
                                    class="po-r mt10 mb10 font-16 ellipsis cu-p flex-box msg-item"
                            >
                                <span>暂无数据</span>
                            </div>
                        </div>
                        <div class="stasticCla" v-if="item.code == 'TINFO_DOWNLOAD'">
                            <p class="po-r mt10 mb10 font-12 ellipsis cu-p flex-box msg-item"  v-for="(e, i) in downloadList" :key="i" >
                                <span class="flex-1 mr10 ellipsis" @click="goHref(e, '/notifyDetail')">{{e.name}}</span>
                                <!--<span class="flex-1 mr10 ellipsis" @click="downLoadFile(e)">{{e.name}}</span>-->
                                <span class="grey">{{e.createTime}}</span>
                            </p>
                            <div
                                    v-if="!downloadList.length"
                                    class="po-r mt10 mb10 font-16 ellipsis cu-p flex-box msg-item"
                            >
                                <span>暂无数据</span>
                            </div>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
    import { tableList, fileDownload, getNoticeList, bpmnStuAndteachStastic } from "@/api/portrayal/policy";
    import { getUser } from "@/api/management/user";
    import { stuAndteachStastic } from "@/api/home/home";
    import {getCardList} from '@/api/managementCenter/specialManage'
    import { handleDownload} from '@/api/managementCenter/otherApi';
    export default {
        name: "LINKMAGA",
        components: {},
        props: ["moduleData"],
        data() {
            return {
                baseUrl: process.env.BASE_URL,
                loading: false,
                rulesList: [],
                businessList: [],
                downloadList: [],
            };
        },
        computed: {},
        created() {
            this.getCardData('3');
            this.getCardData('4');
            this.getCardData('5');
        },
        mounted() {},
        destroyed() {},
        methods: {
            getCardData(type){
                let params = {
                    type: type || ''
                }
                getCardList(params).then(res =>{
                    if(type == '3'){
                        this.rulesList = res.data.data.records
                    }
                    if(type == '4'){
                        this.businessList = res.data.data.records
                    }
                    if(type == '5'){
                        this.downloadList = res.data.data.records
                    }
                })
            },
            handleWidth(col) {
                switch (col) {
                    case 1:
                        return "100%";
                    case 2:
                        return "50%";
                    case 3:
                        return "33.3%";
                    case 4:
                        return "25%";
                    case 5:
                        return "20%";
                    case 6:
                        return "16.6%";
                    default:
                        return "50%";
                }
            },
            clickServeItem(item) {
                switch (item.serveType) {
                    case 0:
                        this.$router.push({
                            path: `/serveSearch/${item.id}/${item.interfaceUrl}`,
                        });
                        break;
                    case 1:
                        this.$router.push({
                            path: `/serveApproval/${item.id}`,
                        });
                        break;
                    case 2:
                        this.$router.push({
                            path: `/serveCustomized/${item.id}/${item.interfaceUrl}`,
                        });
                        break;
                    case 9:
                        this.$http
                            .post(
                                "/statistical/serverInsert",
                                this.$qs.stringify({
                                    serviceId: item.id,
                                    appType: 9,
                                })
                            )
                            .then(() => {})
                            .catch(() => {});

                        this.url = item.linkUrl;

                        this.$nextTick(() => {
                            this.$refs.url.click();
                        });
                        break;
                    default:
                        break;
                }
            },
            iconClick(val){
                val == 'TINFO_RULES' ? this.getCardData('3') :  val == 'TINFO_BUSINESS' ? this.getCardData('4') : this.getCardData('5')
            },
            goHref(item, path){
                let routeData = this.$router.resolve({
                    name: path,
                    query: {
                        id: item.ntiId || item.id,
                        fileId:item.fileId||'',
                        type:item.ntiType||''
                    }
                });
                window.open(routeData.href);
            },
            goPagination(code){
                const type = code === 'TINFO_RULES' ? '3' : code === 'TINFO_BUSINESS'  ?  '4' :'5'
                let routeData = this.$router.resolve({
                    name:'/noticesAndFilesPagination',
                    query: {
                        type,
                    }
                });
                window.open(routeData.href);
            },
            goHref(item, path){
                let routeData = this.$router.resolve({
                    name: path,
                    query: {
                        id: item.ntiId || item.id,
                        fileId:item.fileId||'',
                        type:item.ntiType||''
                    }
                });
                window.open(routeData.href);
            },
            downLoadFile(item){
                this.$DownLoad(
                    handleDownload(item.id),
                    null,
                    res => {
                        if (res.status == 200) {
                        } else {
                            this.$alert("下载出错,请稍后重试", "提示", {
                                confirmButtonText: "确定",
                                type: "warning"
                            });
                        }
                    },
                    error => {
                        this.$alert(error, "提示", {
                            confirmButtonText: "确定",
                            type: "warning"
                        });
                    }
                );
            },
        },
        watch: {},
        filters: {},
    };
</script>

<style scoped>
    .home-card {
        margin: 0 0 20px 0;
        padding: 15px 20px;
        width: 100%;
        height: 233px;
        /*background: #f5f6f8;*/
        background: #fff;
    }

    .msg-item {
        line-height: 24px;
        text-indent: 20px;
    }

    .msg-item:hover {
        background: #ebebec;
    }

    .notReadFlag::before {
        display: block;
        position: absolute;
        content: "";
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: #c84747;
        left: 4px;
        top: calc(50% - 3px);
    }

    .state-box {
        display: inline-block;
        padding: 3px 9px;
        font-size: 12px;
    }

    .state-box-1 {
        color: #0f5892;
        background: #e3edf5;
    }

    .state-box-2 {
        color: #8ac5a7;
        background: #e3ede9;
    }
    .notReadFlag{
        position: relative;
    }
    .card-title{
        color: #024a84;
        border-bottom: 1px solid #ECECEC;
        padding-bottom: 5px;
    }
    .titleClass{
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px #e9e9e9 solid;
        padding: 5px 0;
    }
    ::-webkit-scrollbar {
        display: none;
    }
    .stasticCla{
        height: 170px;
        overflow: auto;
    }
</style>
